import React from "react";
import {
	Link
} from "react-router-dom";
import config from './../../config.js';
import Loading from './../../../components/loading.js';
import Modal from './../../../components/modal.js';
import Actionsheets from './../../../components/actionsheets.js';

import Notification from 'rc-notification';
let notification = null;
Notification.newInstance({
	style: {
		top: '45px',
		right: 0
	}
}, (n) => notification = n);

export default class ListTags extends React.Component {
	constructor(props) {
		super(props);
		//console.log(props);
		let user = {};

		if (typeof localStorage.token !== 'undefined' && localStorage.token !== '') {
			user = JSON.parse(localStorage.user);
		}

		const pagetitle = '标签设置 ';
		this.state = {
			page_title: pagetitle,
			user: user,
			loading: true,
			tags: [],
			modal_title: '添加标签',
			display: false,
			isaction: false,
			currentid: 0,
			name: '',
			description: ''

		}

		document.title = pagetitle;
		this.actionSubmit = this.actionSubmit.bind(this);
		this.close = this.close.bind(this);
		this.modal = this.modal.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);

		this.actionClose = this.actionClose.bind(this);
		this.removeSubmit = this.removeSubmit.bind(this);

	}


	componentDidMount() {
		this.onInitial();
	}


	componentWillReceiveProps(nextProps) {
		//this.onInitial(nextProps);
	}

	notify(message) {
		notification.notice({
			content: <span>{message}</span>,
			duration: 4,
			style: {
				'bottom': 0,
				'right': 0
			}
		});
	}

	handleInputChange(event) {
		const target = event.target;
		//const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;
		const value = target.value;
		this.setState({
			[name]: value
		});
	}


	modal(id) { //modal for delete
		let modal_title = id > 0 ? '修改标签' : '添加标签';
		if (id == 0) {
			this.setState({
				display: true,
				currentid: id,
				modal_title: modal_title,
				origin: '',
				protype: '3D',
				modality: 'MR'
			});

		} else {

			let {
				tags
			} = this.state;
			for (let index in tags) {
				if (tags[index].id === id) {
					this.setState({
						display: true,
						currentid: id,
						modal_title: modal_title,
						name: tags[index].name,
						description: tags[index].description
					});
					break;
				}
			}


		}
	}


	close() { //modal close
		this.setState({
			display: false,
			modal_title: null,
			loading: false
		});
	}


	/**
	 * fetch all brain label names
	 * @param  {[type]} data [description]
	 * @return {[type]}      [description]
	 */
	onInitial() {
		//console.log(data)
		const me = this;
		const {
			user
		} = me.state;

		const postdata = {
			userid: user.id,
			request: 'list',
			Authorization: localStorage.token
		};
		me.setState({
			loading: true
		});
		fetch(config.host + '/tags/index', {
				method: 'post',
				body: JSON.stringify(postdata)
			})
			.then(res => res.json())
			.then(json => {
				//console.log(json);
				if (json.status === 1) {
					me.setState({
						tags: json.data,
						loading: false
					});

				} else {
					me.setState({
						tags: [],
						loading: false
					});
				}
			})
			.catch(function(error) {
				console.log(error);
			});
	}


	/**
	 * create and generate report
	 * @return {[type]} [description]
	 */
	actionSubmit() {
		const me = this;
		let {
			user,
			tags,
			name,
			description,
			currentid
		} = me.state;

		if (name == '') {
			me.notify('请填写标签规则');
			return;
		}

		const postdata = {
			userid: user.id,
			name: name,
			description: description,
			currentid: currentid,
			request: currentid == 0 ? 'insert' : 'update',
			Authorization: localStorage.token
		};
		me.setState({
			loading: true
		});

		fetch(config.host + '/tags/index', {
				method: 'post',
				body: JSON.stringify(postdata)
			})
			.then(res => res.json())
			.then(json => {
				//console.log(json);
				me.notify(json.message);
				if (json.status === 1) {
					if (currentid == 0) {
						tags.splice(0, 0, json.data);
						//console.log(tags)
					} else {
						for (let index in tags) {
							if (tags[index].id === currentid) {
								tags[index] = json.data;
								break;
							}
						}
					}
					me.setState({
						tags: tags,
						display: false

					});
				}

				me.setState({
					loading: false
				});

			})
			.catch(function(error) {
				console.log(error);
			});

	}


	actionClose() {
		this.setState({
			isaction: false
		})
	}


	remove(id) {
		this.setState({
			currentid: id,
			isaction: true
		})
	}

	removeSubmit() {
		const me = this;
		let {
			user,
			currentid,
			tags
		} = me.state;

		const postdata = {
			userid: user.id,
			currentid: currentid,
			request: 'remove',
			Authorization: localStorage.token
		};

		me.setState({
			loading: true
		});

		fetch(config.host + '/tags/index', {
				method: 'post',
				body: JSON.stringify(postdata)
			})
			.then(res => res.json())
			.then(json => {
				//console.log(json);
				me.notify(json.message);
				if (json.status === 1) {
					for (let index in tags) {
						if (tags[index].id === currentid) {
							delete tags[index];
							break;
						}
					}
					me.setState({
						tags: tags,
						display: false
					});
				}

				me.setState({
					loading: false,
					isaction: false
				});

			})
			.catch(function(error) {
				console.log(error);
			});
	}


	render() {
		const me = this;
		const {
			page_title,
			user,
			tags,
			name,
			description
		} = me.state;

		return (
			<div className="container-fluid">
				<Loading display={me.state.loading} />
				<nav className="clearfix mt-3">
					<h4 className="animated fadeInLeft float-left"><i className="fa fa-data"></i> {page_title} <small>共{tags.length}条</small></h4>
					<div className="float-right">
						<button className="btn btn-sm btn-danger" onClick={()=>this.modal(0)}>添加标签</button>
					</div>
				</nav>

	            <div className="clearfix py-3 ">
	            	<table className="table table-dark table-hover">
	            	<thead className="thead-dark">
	            		<tr>
	            			<th>标签名称</th>
	            			<th></th>
	            			<th></th>
	            		</tr>
	            	</thead>
	            	<tbody>
					{
						tags.length > 0 && tags.map((p,i)=>{
							return(
								<tr key={i}>
									<td>{p.name}</td>
									<td>{p.description}</td>
									<td className="text-right px-3">
									<span className="px-3"><a onClick={()=>this.modal(p.id)}>编辑</a></span>
									<span><a className="text-danger" onClick={()=>this.remove(p.id)}>删除</a></span>
									</td>
								</tr>
								)
						})
					}

	            	</tbody>
	            	</table>
				</div>

		        <Modal title={this.state.modal_title} display={this.state.display} close={this.close} submit={this.actionSubmit}>

		                  <form className="pr-4">
		                    <div className="form-group row">
		                      <label className="col-sm-4 col-form-label text-right">标签名称：</label>
		                      <div className="col-sm-8"> <input type="text" className="form-control" maxlength="10" value={name} onChange={this.handleInputChange} placeholder="Tag name" name="name" required />
		                      </div>
		                    </div>
		                    <div className="form-group row">
		                      <label className="col-sm-4 col-form-label text-right">备注：</label>
		                      <div className="col-sm-8"> <input type="text" className="form-control" value={description} onChange={this.handleInputChange} placeholder="Tag description" name="description" maxlength="50" required />
		                      </div>
		                    </div>
		                  </form>
		        </Modal>



				<Actionsheets display={this.state.isaction}>
					<ul className="list-group text-center">
						<li className="list-group-item disabled">确定要删除?</li>
						<li className="list-group-item text-danger" onClick={this.removeSubmit}>删除</li>
						<li className="list-group-item" onClick={this.actionClose}>取消</li>
					</ul>
				</Actionsheets>
	        </div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/apps/console/prototype/list_tags.js